var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 13.519c-.368-.246-.443-.71-.167-1.037L5.458 7 .833 1.52C.557 1.192.632.727 1 .482c.368-.246.89-.18 1.167.148l5 5.926a.676.676 0 0 1 0 .889l-5 5.926c-.276.327-.799.393-1.167.148",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;